import { render, staticRenderFns } from "./DialogRelatoriosPadroes.vue?vue&type=template&id=07ed1dad"
import script from "./DialogRelatoriosPadroes.vue?vue&type=script&lang=js"
export * from "./DialogRelatoriosPadroes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports